import _ from 'underscore';

import {BenchlingState, SelectorFunction} from '../redux-stores/reduceApp';
import ErrorSubclass from '../util/ErrorSubclass';

export class NotYetFetchedException extends ErrorSubclass {}

/**
 * Retrieves the state object prescribed by `selectorFunction` from the redux store if present,
 * otherwise throws a custom exception to indicate to callers that the specified state object
 * has not yet been fetched.
 */
export function defensiveGetState<T>(reduxState: BenchlingState, selectorFunction: SelectorFunction<T>): T {
  const state = selectorFunction(reduxState);
  if (state && !_.isEmpty(state)) {
    return state;
  }
  throw new NotYetFetchedException(`Not yet fetched state for selector ${selectorFunction}`);
}

/**
 * Retrieves the value for `key` from the given state object if present, otherwise throws a custom
 * exception to indicate to callers that the value for the specified key has not yet been fetched.
 */
export function defensiveGetFromState<V>(stateObject: {[key: string]: V}, key: string): V {
  if (stateObject.hasOwnProperty(key)) {
    return stateObject[key];
  }
  throw new NotYetFetchedException(`Not yet fetched state for key ${key}`);
}
